import { authExchange } from '@urql/exchange-auth';

import { redirectToLogin, refetchToken } from '@shared/auth/auth';
import { tokenStore, isImpersonating, isTokenValidOrUndefined } from '@shared/auth/token.store';

export const auth = authExchange(async (utils) => {
  // Await is required by the authExchange initializer contract
  await Promise.resolve();

  return {
    addAuthToOperation(operation) {
      const token = tokenStore.getState().accessToken?.token;
      let tenantId = '';
      if (token) {
        try {
          const payload = JSON.parse(atob(token.split('.')[1] ?? '')) as {
            tenantId?: string;
          };
          tenantId = payload.tenantId ?? '';
        } catch {
          /* ignore */
        }
      }
      return utils.appendHeaders(operation, {
        Authorization: token ? `Bearer ${token}` : '',
        'X-Tenant-Id': tenantId,
        'X-Platform': 'crm',
        'Accept-Language': localStorage.getItem('i18nextLng') ?? 'en',
      });
    },

    willAuthError() {
      return !isTokenValidOrUndefined();
    },

    didAuthError(error) {
      return error.graphQLErrors.some((e) => {
        const code = (e.extensions as Record<string, unknown> | undefined)?.['code'] as
          | string
          | undefined;
        return code === 'UNAUTHENTICATED';
      });
    },

    async refreshAuth() {
      if (isImpersonating()) {
        redirectToLogin();
        return;
      }
      try {
        await refetchToken();
      } catch {
        redirectToLogin();
      }
    },
  };
});
